export default __webpack_public_path__ + "static/media/restaurant-7-rMAX.d1be8cb3.jpg";